import React, { useState } from 'react'
import {
  Content,
  ErrorMessage,
  FunderSharedGoalsContainer,
  Header,
  SuccessMessage,
} from './FunderSharedGoals.styled'
import { FEEDBACK_TIMEOUT } from './constants'
import { Ribbon } from '../_common/Ribbon'
import { ChartCreation } from './ChartCreation'
import { GoalCreation } from './GoalCreation'
import { FunderSharedGoalTabs } from './FunderSharedGoalTabs'
import { FunderCollaborationTabsEnum } from '../_common/types'
import { GoalGroupCreation } from './GoalGroupCreation'

export const FunderSharedGoals = () => {
  const [activeTab, setActiveTab] = useState(
    FunderCollaborationTabsEnum.goalGroupCreation
  )
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const popError = (message: string) => {
    setError(message)
    setTimeout(() => setError(''), FEEDBACK_TIMEOUT)
  }

  const popSuccess = (message: string) => {
    setSuccess(message)
    setTimeout(() => setSuccess(''), FEEDBACK_TIMEOUT)
  }

  return (
    <FunderSharedGoalsContainer>
      <Ribbon />
      <Header>Funder Collaboration</Header>
      <Content>
        <FunderSharedGoalTabs
          activeTab={activeTab}
          onChangeTab={setActiveTab}
        />
        {activeTab === FunderCollaborationTabsEnum.goalGroupCreation && (
          <GoalGroupCreation popError={popError} popSuccess={popSuccess} />
        )}
        {activeTab === FunderCollaborationTabsEnum.goalCreation && (
          <GoalCreation popError={popError} popSuccess={popSuccess} />
        )}
        {activeTab === FunderCollaborationTabsEnum.chartCreation && (
          <ChartCreation popError={popError} popSuccess={popSuccess} />
        )}
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {success && <SuccessMessage>{success}</SuccessMessage>}
      </Content>
    </FunderSharedGoalsContainer>
  )
}
